import React from 'react'
import PropTypes from 'prop-types'
import '../assets/css/components/hint-button.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
library.add(faInfoCircle)


const HintButton = props => {
  return(
    <span className={'hint-button ' + (props.alignment ? props.alignment : '')}>
      <FontAwesomeIcon icon='info-circle' color={props.iconColor ? props.iconColor : '#00C8E4'}/>
      <div className='hint-container'>
        <div className='hint-box' style={{ backgroundColor: props.hintBoxColor ? props.hintBoxColor : '#353C43'}}>
          <div className={props.arrowDirection ? props.arrowDirection : "up"}></div>
          <span className='hint' style={{color: (props.hintTextColor ? props.hintTextColor : "white")}}>{props.hint}</span>
        </div>
      </div>
    </span>
  )
}

HintButton.propTypes = {
  //the actual content of the hint within the box. Can be either just text or an html component
  hint: PropTypes.oneOfType([PropTypes.symbol, PropTypes.string, PropTypes.element]).isRequired,
  //The defined alignment of popout. Currently only left and center (which is default) are programmed
  alignment: PropTypes.string,
  //Wether the arrow appears above or below the popout box, default is up
  arrowDirection: PropTypes.string,
  //the color of the information icon, default is TytoBlue (as used in track progress)
  iconColor: PropTypes.string,
  //the color of the hint box background
  hintBoxColor: PropTypes.string,
  //The text color of the hint text within the hint box
  hintTextColor: PropTypes.string
};
export default HintButton
